import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';
import { TRACKING_ACTION, TRACKING_INTERACTION } from 'contexts/AnalyticsContext/Constants';

export const utagCloseComparisonClicked = () => {
    const event = {
        eventType: TRACKING_ACTION.INTERACTION,
        interaction: TRACKING_INTERACTION.COMPARE.CLOSE_COMPARISON
    }
    const userInteractionEvent = createUserInteraction(event);
    trackEvent(userInteractionEvent);
}